import "./imageSection.css";

import React from "react";

const ImageSection = ({ mainImg, hrefLink }) => {

  return (
    <section className={"image-section"}>
      <div className={"image-cont full-width"}>
        {
          <React.Fragment>
            <a 
              href={hrefLink}
              target={"_blank"} 
              rel={"noreferrer"}
            >
              <img
                className={"image-main-img"}
                src={mainImg}
              />
            </a>
          </React.Fragment>
        }
        
      </div>
    </section>
  );
};

export default ImageSection;